.panel {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-3);
  min-width: 18rem;
  max-width: 22rem;
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
  background: var(--tuna-surface-elevated);
}

.title {
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
  margin: 0;
}

.hint,
.empty {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
  margin: 0;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
}

.listItem {
  margin: 0;
}

@media (max-width: 899.95px) {
  .panel {
    max-width: 100%;
    width: 100%;
  }
}
